var path = 'app/scripts/modules/core/src/pipeline/config/stages/baseProviderStage/baseProviderStage.html';
var html = "<div class=\"form-horizontal\" ng-if=\"!viewState.loading\">\n  <stage-config-field label=\"Provider\" ng-if=\"providers.length > 1\">\n      <provider-selector providers=\"providers\"\n                         component=\"stage\" field=\"cloudProviderType\"\n                         read-only=\"!stage.isNew\"></provider-selector>\n  </stage-config-field>\n  <div ng-include=\"providerStageDetailsUrl\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/baseProviderStage/baseProviderStage.html
// module id = 1000
// module chunks = 0